import { useLocation } from "react-router-dom";

import Breadcrumbs from "components/Breadcrumbs/Breadcrumbs";
import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";
import Intro from "components/Intro/Intro";
import IntroIllustration from "components/Intro/IntroIllustration/IntroIllustration";
import IntroPoints from "components/Intro/IntroPoints/IntroPoints";
import { isIntroWithPointsPage } from "components/Breadcrumbs/ConditionalBreadcrumbs/ConditionalBreadcrumbs";

import "./IntroWithPoints.scss";

const PLATFORMS = {
  'prodvizhenie-trekov-yandexmusic': { color: '#EEB010', class: 'yandexmusic' },
  'prodvizhenie-trekov-yandexmusic-presave': { color: '#EEB010', class: 'yandexmusic' },
  'prodvizhenie-trekov-yandexmusic-proslushka': { color: '#EEB010', class: 'yandexmusic' },
  'prodvizhenie-trekov-vkmusic': { color: '#63BFF2', class: 'vkmusic' },
  'prodvizhenie-trekov-vkmusic-presave': { color: '#63BFF2', class: 'vkmusic' },
  'prodvizhenie-trekov-vkmusic-proslushka': { color: '#63BFF2', class: 'vkmusic' },
  'promotion-on-spotify': { color: '#54c28b', class: 'spotify' },
  'promotion-on-applemusic': { color: '#b5b3b4', class: 'applemusic' },
};

export default function IntroWithPoints({
  title,
  comment,
  points,
  marketMode,
  hiddenContent,
  isTablet,
  isMobile,
}) {
  const location = useLocation();
  const path = (marketMode?.path ?? '').replace(/^\//, '');
  const platform = PLATFORMS[path] || { color: '#EEB010', class: '' };
  const classesReviewAvito = path.includes('reviews-na-obyavleniya');
  const classesReviewYandex = path.includes('reviews-on-yandexmaps');
  const shouldShowBreadcrumbs = isIntroWithPointsPage(location.pathname);

  return (
    <section className={`intro-with-points ${platform.class} ${shouldShowBreadcrumbs ? 'with-breadcrumbs' : ''}`}>
      {shouldShowBreadcrumbs && <Breadcrumbs shouldShowBreadcrumbs={true} />}
      {isMobile && <>{classesReviewAvito || classesReviewYandex ? <div className={`intro-markets__container-review ${classesReviewAvito ? 'avito' : 'yandex'}`}/> : <IntroIllustration marketMode={marketMode} shouldShowBreadcrumbs={shouldShowBreadcrumbs} />}</>}
      <Intro title={title} comment={comment} marketMode={marketMode} isTablet={isTablet} isMobile={isMobile} hiddenContent={hiddenContent} classesReviewAvito={classesReviewAvito} classesReviewYandex={classesReviewYandex} shouldShowBreadcrumbs={shouldShowBreadcrumbs}>
        <div className="intro-with-points__info-container">
          <div className={`intro-with-points__comment ${shouldShowBreadcrumbs ? 'with-breadcrumbs' : ''}`}>{comment}</div>
          {(isMobile || isTablet) ? <IntroPoints stepLength={points} /> : 
            <ul className="intro-with-points__list">
              {points?.map((point, i) => 
                <li key={i}>
                  <svg style={{ color: platform.color }} width="16" height="17" xmlns="http://www.w3.org/2000/svg"><path d="M9.163 9.663V16.5H6.837V9.663H0V7.337h6.837V.5h2.326v6.837H16v2.326H9.163z" fill="currentColor"/></svg>
                  {point}
                </li>
              )}
            </ul>
          }
          {!isMobile && marketMode.bots && <ButtonWithIcon title="Скачать презентацию" ariaLabel="Скачать презентацию" to="/docs/presentation-ya-pf.pdf" target="_blank" className="button-with-icon" />}
        </div>
      </Intro>
    </section>
  );
}